import React, { useState, useEffect } from "react";
import Select from "react-select";
import { FaChevronDown, FaCheck, FaCheckCircle } from "react-icons/fa";
import { State, City } from "country-state-city";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import OrderSummary from "../../Common/Ordersummary";
import { 
    useDeleteFromCartMutation, 
    useAddressMutation, 
    useEditAddressMutation, 
    useLazyViewAddressQuery, 
    useLazyCartViewQuery, 
    useOrderconfirmMutation 
} from "../../redux/Api/api";
import { saveCartCountHandler } from "../../redux/reducer/CartCountSlice";
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Checkout = () => {
    const [phoneNumber, setPhoneNumber] = useState("");
    const [pincode, setPincode] = useState("");
    const [cartItems, setCartItems] = useState([]);
    const [address, setAddress] = useState("");
    const [states, setStates] = useState([]);
    const [quantities, setQuantities] = useState([]);
    const [cartCount, setCartCount] = useState(0);
    const [cities, setCities] = useState([]);
    const [deliveryCompleted, setDeliveryCompleted] = useState(false);
    const [paymentCompleted, setPaymentCompleted] = useState(false);
    const [showRemovePopup, setShowRemovePopup] = useState(null);
    const [selectedPayment, setSelectedPayment] = useState("cash_on_delivery");
    const [selectcheckbox, setselectCheckbox] = useState(false);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [formedit, setFormEdit] = useState(false);
    const [activeAccordion, setActiveAccordion] = useState(null);
    const [fullData, setFulllData] = useState(null);
    const [addressList, setAddressList] = useState([]);
    const [addrestype, setAddressType] = useState('');
    const [selectedAddress, setSelectedAddress] = useState(null);

    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const buyNowProduct = location.state?.buyNowProduct;
    const user = JSON.parse(localStorage.getItem("user"));

    const [deleteFromCart] = useDeleteFromCartMutation();
    const [addresspost] = useAddressMutation();
    const [getaddress] = useLazyViewAddressQuery();
    const [editaddress] = useEditAddressMutation();
    const [orderconfirm] = useOrderconfirmMutation();
    const [cartlist] = useLazyCartViewQuery();
    const [fetchCart] = useLazyCartViewQuery();

    useEffect(() => {
        if (user && user._id) {
            fetchCart(user._id)
                .unwrap()
                .then((items) => {
                    let allItems = [...items];
                    
                    if (buyNowProduct) {
                        allItems = [...allItems, {
                            product: buyNowProduct.product,
                            quantity: buyNowProduct.quantity || 1,
                            _id: Date.now().toString()
                        }];
                    }
                    
                    setCartItems(allItems);
                    setQuantities(allItems.map((item) => item.quantity || 1));
                    setCartCount(allItems.length);
                })
                .catch((err) => {
                    console.error("Error fetching cart data:", err);
                    toast.error("Error fetching cart items.");
                });
        } else {
            toast.error("Please log in first.");
        }
    }, [buyNowProduct]);

    useEffect(() => {
        const indianStates = State.getStatesOfCountry("IN").map((state) => ({
            value: state.isoCode,
            label: state.name,
        }));
        setStates(indianStates);
        viewaddress();
    }, []);

    const handleStateChange = (selectedOption) => {
        setSelectedState(selectedOption);
        setSelectedCity(null);
        const stateCities = City.getCitiesOfState("IN", selectedOption.value).map((city) => ({
            value: city.name,
            label: city.name,
        }));
        setCities(stateCities);
    };

    const getcartlist = () => {
        if (user?._id) {
            cartlist(user._id)
                .unwrap()
                .then(res => {
                    dispatch(saveCartCountHandler(res?.length));
                })
                .catch(err => {
                    console.error('Error fetching cart:', err);
                });
        }
    };

    const handleAccordionClick = (section) => {
        setActiveAccordion(activeAccordion === section ? null : section);
    };

    const handleAddressSubmit = () => {
        if (!user?._id) {
            toast.error("User ID is required.");
            return;
        }

        const payload = {
            userId: user._id,
            mobileNumber: phoneNumber,
            pincode: pincode,
            address: address,
            city: selectedCity?.label,
            state: selectedState?.label,
        };

        if (addrestype === "add") {
            addresspost(payload)
                .unwrap()
                .then((res) => {
                    setAddressList((prev) => [...prev, res?.data]);
                    setFormEdit(false);
                    viewaddress();
                    toast.success("New address added successfully!");
                })
                .catch(() => {
                    toast.error("Failed to add new address.");
                });
        } else if (addrestype === "edit") {
            editaddress({ payload: payload, id: fullData?._id })
                .unwrap()
                .then((res) => {
                    setAddressList((prev) =>
                        prev.map((item) => (item._id === fullData?._id ? res?.data : item))
                    );
                    setFormEdit(false);
                    toast.success("Address edited successfully!");
                })
                .catch(() => {
                    toast.error("Failed to edit address.");
                });
        }

        setPhoneNumber("");
        setPincode("");
        setAddress("");
        setSelectedState(null);
        setSelectedCity(null);
    };

    const handleRemove = (item) => {
        const cartItemId = item._id;
        if (!cartItemId) {
            toast.error("Unable to remove item.");
            return;
        }

        deleteFromCart(cartItemId)
            .unwrap()
            .then(() => {
                getcartlist();
                setCartItems((prevItems) => prevItems.filter((cartItem) => cartItem._id !== cartItemId));
                toast.success("Item removed successfully.");
            })
            .catch((err) => {
                console.error("Error removing item from cart:", err);
                toast.error("Error removing item from cart.");
            });
    };

    const confirmRemove = (item) => {
        handleRemove(item);
        setShowRemovePopup(null);
    };

    const cancelRemove = () => {
        setShowRemovePopup(null);
    };

    const handleConfirm = () => {
        if (!user?._id || !selectedAddress?._id) {
            toast.error("Please select an address and ensure you're logged in.");
            return;
        }

        const filteredItems = cartItems.map((item) => ({
            product: buyNowProduct && item.product._id === buyNowProduct.product._id 
                ? buyNowProduct.product._id 
                : item.product._id,
            quantity: item.quantity || 1,
            price: item.product.price
        }));

        const payload = {
            userId: user._id,
            addressId: selectedAddress._id,
            cartItems: filteredItems,
            cashOnDelivery: true
        };

        orderconfirm(payload)
            .unwrap()
            .then(res => {
                toast.success("Order confirmed successfully!");
                navigate('/order', { state: res });
            })
            .catch(err => {
                console.error('Error confirming order:', err);
                toast.error("Failed to confirm order");
            });
    };

    const viewaddress = () => {
        if (!user?._id) {
            toast.error("Please log in to view addresses");
            return;
        }

        getaddress(user._id)
            .unwrap()
            .then((res) => {
                if (!res?.data || res.data.length === 0) {
                    setFormEdit(true);
                } else {
                    const userAddresses = res.data.filter(addr => addr.userId === user._id);
                    setAddressList(userAddresses);
                    setFormEdit(false);

                    if (!selectedAddress && userAddresses.length > 0) {
                        const firstAddress = userAddresses[0];
                        setSelectedAddress(firstAddress);
                        setFulllData(firstAddress);
                        setAddress(firstAddress.address);
                        setPhoneNumber(firstAddress.mobileNumber);
                        setSelectedState({ label: firstAddress.state });
                        setSelectedCity({ label: firstAddress.city });
                        setPincode(firstAddress.pincode);
                    }
                }
            })
            .catch((err) => {
                console.error("Error fetching addresses:", err);
                toast.error("Failed to fetch addresses");
            });
    };

    return (
        <div className="p-4 mt-20 md:mt-60">
            <div className="flex flex-col md:flex-row gap-5 md:ml-28">
                <div className="w-full md:w-2/4">
                    {["Shipping Info", "Delivery Info", "Payment Info"].map((section, index) => (
                        <div
                            key={index}
                            className={`border border-gray-300 p-4 md:p-6 bg-white mb-4 md:mb-6 rounded-lg 
                                ${section === "Delivery Info" && !fullData?.address ? "opacity-50 cursor-not-allowed" : ""} 
                                ${section === "Payment Info" && (!fullData?.address || !deliveryCompleted) ? "opacity-50 cursor-not-allowed" : ""}`}>
                            <h1
                                className={`font-bold text-xl md:text-2xl flex justify-between items-center 
                                    ${section === "Delivery Info" && !fullData?.address ? "pointer-events-none" : "cursor-pointer"} 
                                    ${section === "Payment Info" && (!fullData?.address || !deliveryCompleted) ? "pointer-events-none" : "cursor-pointer"}`}
                                onClick={() => {
                                    if (
                                        (section === "Shipping Info") ||
                                        (section === "Delivery Info" && fullData?.address) ||
                                        (section === "Payment Info" && fullData?.address && deliveryCompleted)
                                    ) {
                                        handleAccordionClick(section);
                                    }
                                }}>
                                <div className="flex items-center gap-2 md:gap-3">
                                    <div className="w-4 h-4 md:w-5 md:h-5 flex items-center justify-center rounded-full border">
                                        {((section === "Shipping Info" && fullData?.address) ||
                                            (section === "Delivery Info" && deliveryCompleted) ||
                                            (section === "Payment Info" && paymentCompleted)) ? (
                                            <FaCheckCircle className="text-white bg-blue-500 rounded-full p-1 w-4 h-4 md:w-5 md:h-5" />
                                        ) : (
                                            <FaCheckCircle className="text-gray-700 w-5 h-5" />
                                        )}
                                    </div>
                                    {section}
                                </div>
                                <FaChevronDown
                                    className={`transition-transform duration-300 ${activeAccordion === section ? "rotate-180" : ""}`}
                                />
                            </h1>

                            {activeAccordion === section && (
                                <div className="mt-3 md:mt-4">
                                    {section === "Shipping Info" && (
                                        <>
                                            {formedit ? (
                                                <form>
                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-10 mt-4">
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700">Mobile Number</label>
                                                            <div className="flex items-center mb-2 w-full">
                                                                <span className="px-4 py-3 mt-2 block border border-r-0 border-gray-500">+91</span>
                                                                <input
                                                                    type="number"
                                                                    value={phoneNumber}
                                                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                                                    placeholder="Enter Your Mobile Number"
                                                                    className="mt-2 block w-full px-4 py-3 border border-gray-500 shadow-sm focus:outline-none"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700">Pincode</label>
                                                            <input
                                                                type="text"
                                                                value={pincode}
                                                                onChange={(e) => setPincode(e.target.value)}
                                                                className="mt-2 block w-full px-4 py-3 border border-gray-500 shadow-sm focus:outline-none"
                                                                placeholder="Pincode"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="mt-4">
                                                        <label className="block text-sm font-medium text-gray-700">Address</label>
                                                        <input
                                                            type="text"
                                                            value={address}
                                                            onChange={(e) => setAddress(e.target.value)}
                                                            className="mt-2 block w-full px-4 py-3 border border-gray-500 shadow-sm focus:outline-none"
                                                            placeholder="Address"
                                                        />
                                                    </div>
                                                    <div className="grid grid-cols-1 md:grid-cols-2 md:gap-16 mt-4">
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700">State</label>
                                                            <Select
                                                                options={states}
                                                                value={selectedState}
                                                                onChange={handleStateChange}
                                                                placeholder="Select a state"
                                                            />
                                                        </div>
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700">City</label>
                                                            <Select
                                                                options={cities}
                                                                value={selectedCity}
                                                                onChange={setSelectedCity}
                                                                placeholder="Select a city"
                                                                isDisabled={!selectedState}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="flex justify-start mt-5">
                                                        <button
                                                            type="button"
                                                            className="bg-[#FF0004] text-white px-10 py-3 rounded hover:bg-red-700"
                                                            onClick={handleAddressSubmit}>
                                                            Save and Deliver Here
                                                        </button>
                                                    </div>
                                                </form>
                                            ) : (
                                                <div className="mt-10">
                                                    {addressList?.length > 0 ? (
                                                        addressList.map((item, index) => (
                                                            <div key={index} className="shadow-md border border-gray-300 p-5 bg-white mb-5 rounded-2xl">
                                                                <div className="flex justify-between items-center">
                                                                    <div className="flex items-start">
                                                                        <input
                                                                            type="radio"
                                                                            name="address"
                                                                            className="mt-2 mr-4 p-1 w-5 h-5"
                                                                            checked={selectedAddress === item}
                                                                            onChange={() => {
                                                                                setSelectedAddress(item);
                                                                                setFulllData(item);
                                                                            }}
                                                                        />
                                                                        <div>
                                                                            <h1 className="font-bold text-xl">DELIVERY ADDRESS</h1>
                                                                            <h3 className="font-light text-lg mt-2">{item.mobileNumber}</h3>
                                                                            <p className="font-light text-lg">
                                                                                {item.address}, {item.pincode}, {item.state}, {item.city}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <button
                                                                        onClick={() => {
                                                                            setFulllData(item);
                                                                            setAddress(item.address);
                                                                            setPhoneNumber(item.mobileNumber);
                                                                            setPincode(item.pincode);
                                                                            setSelectedState({ label: item.state });
                                                                            setSelectedCity({ label: item.city });
                                                                            setFormEdit(true);
                                                                            setAddressType("edit");
                                                                        }}
                                                                        className={`px-6 py-2 rounded ${selectedAddress === item ? "bg-blue-500 text-white hover:bg-blue-600" : "bg-gray-300 text-gray-600 cursor-not-allowed"} w-full md:w-auto`}
                                                                        disabled={selectedAddress !== item}
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <p>No addresses found. Please add one.</p>
                                                    )}
                                                    <button
                                                        onClick={() => {
                                                            setPhoneNumber("");
                                                            setPincode("");
                                                            setAddress("");
                                                            setSelectedState(null);
                                                            setSelectedCity(null);
                                                            setFormEdit(true);
                                                            setAddressType("add");
                                                        }}
                                                        className="bg-green-500 text-white px-12 py-2 rounded mt-5 hover:bg-green-600"
                                                    >
                                                        + Add a new address
                                                    </button>
                                                </div>
                                            )}
                                        </>
                                    )}

                                    {section === "Delivery Info" && fullData?.address && (
                                        <div>
                                            <div className="flex flex-col">
                                                <div className="">
                                                    {cartItems.map((item) => (
                                                        <div
                                                            key={item._id}
                                                            className="flex flex-col md:flex-row shadow-md border border-gray-300 bg-white p-5 mb-5"
                                                        >
                                                            <div className="md:w-1/3 p-3 flex justify-center items-center">
                                                                <img
                                                                    src={item.product?.image ? item.product.image : "/placeholder.png"}
                                                                    alt={item.product?.name || "Product image not available"}
                                                                    className="w-32 h-32 md:w-30 md:h-24 object-cover rounded-lg shadow"
                                                                />
                                                            </div>
                                                            <div className="md:w-2/3 p-1">
                                                                <h3 className="text-xl font-bold mb-4">{item.product?.name || "N/A"}</h3>
                                                                <p className="text-gray-600 mb-4">{item.product?.description || "No description available"}</p>
                                                                <p className="font-bold text-lg mb-4">Rs {item.product?.price || 0}</p>
                                                                <div className="flex items-center justify-between mb-2">
                                                                    <p className="text-gray-700">Quantity: {item.quantity || 1}</p>
                                                                    <button
                                                                        onClick={() => setShowRemovePopup(item)}
                                                                        className="text-black hover:text-blue-600 text-xl"
                                                                    >
                                                                        Remove
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    <div className="flex justify-start mt-5">
                                                        <button
                                                            type="button"
                                                            className="bg-[#FF0004] text-white px-10 py-3 rounded hover:bg-red-700"
                                                            onClick={() => setDeliveryCompleted(true)}
                                                        >
                                                            Continue
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {section === "Payment Info" && fullData?.address && deliveryCompleted && (
                                        <div>
                                            <p className="font-semibold text-gray-500 text-lg md:mt-7">Select your payment option:</p>
                                            <div className="mt-4 space-y-3">
                                                <label className="flex items-center space-x-3">
                                                    <input
                                                        type="radio"
                                                        name="payment_option"
                                                        value="cash_on_delivery"
                                                        checked={selectedPayment === "cash_on_delivery"}
                                                        onChange={() => setSelectedPayment("cash_on_delivery")}
                                                        className="w-5 h-5"
                                                    />
                                                    <span>Cash on Delivery</span>
                                                </label>
                                            </div>

                                            <div className="mt-10 flex items-start space-x-3">
                                                <input
                                                    type="checkbox"
                                                    checked={selectcheckbox}
                                                    onChange={(e) => setselectCheckbox(e.target.checked)}
                                                    className="w-5 h-5 mt-1"
                                                />
                                                <span>
                                                    I agree to the{" "}
                                                    <Link to="/terms" className="text-blue-700">terms and conditions</Link>
                                                    {" "}&{" "}
                                                    <Link to="/return" className="text-blue-700">return policy</Link>
                                                    {" "}&{" "}
                                                    <Link to="/privacy" className="text-blue-700">privacy policy</Link>
                                                    {" "}&{" "}
                                                    <Link to="/support" className="text-blue-700">support policy</Link>
                                                </span>
                                            </div>

                                            <div className="flex justify-start mt-5">
                                                <button
                                                    type="button"
                                                    className={`px-10 py-3 rounded ${!selectcheckbox
                                                        ? "bg-gray-400 cursor-not-allowed"
                                                        : "bg-[#FF0004] hover:bg-red-700"
                                                        } text-white`}
                                                    onClick={handleConfirm}
                                                    disabled={!selectcheckbox}
                                                >
                                                    Confirm Order
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                <OrderSummary />
            </div>

            {showRemovePopup && (
                <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
                    <div className="bg-white p-6 rounded shadow-lg">
                        <h2 className="text-lg font-bold mb-4">
                            Are you sure you want to remove this item?
                        </h2>
                        <div className="flex justify-end">
                            <button
                                onClick={() => confirmRemove(showRemovePopup)}
                                className="bg-red-500 text-white px-4 py-2 rounded mr-2 hover:bg-red-600"
                            >
                                Remove
                            </button>
                            <button
                                onClick={cancelRemove}
                                className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Checkout;